import {
  Directive,
  Input,
  ViewContainerRef,
  OnInit,
  ElementRef,
  ComponentFactoryResolver,
  ComponentRef,
  OnDestroy,
} from "@angular/core";
import { NgControl } from "@angular/forms";
import { ControlErrorComponent } from "src/app/components/form-elements/control-error/control-error.component";
import { Subscription } from "rxjs";

const urlReg = "^(https?)://(www.)?[^s]+.[^s]{2,}$";
// const urlReg = '^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})$';

const customErrorMessages = {
  required: (error) => "ეს ველი სავალდებულოა",
  minlength: ([requredLength, actualLength]) =>
    `მინიმალური სიგრძე ${requredLength}`,
  maxlength: ([requredLength, actualLength]) =>
    `მაქსიმალური სიგრძე ${requredLength}`,
  min: ([requredVal, actualVal]) => `მინიმალური მნიშველობა ${requredVal}`,
  max: ([requredVal, actualVal]) => `მაქსიმალური მნიშველობა ${requredVal}`,
  pattern: ([example, pattern]) =>
    `მითითებული მობილური ნომერის ფორმატი არასწორია 5XXXXXXXX`,
  email: (email) =>
    !email.length
      ? `ელ-ფოსტის ფორმატი არასწორია, მაგ: example@example.com`
      : email,
  mustMatch: () => "პაროლები უნდა ემთხვეოდეს ერთმანეთს",
  year: (age) => (!age.length ? "მომხმარებელი უნდა იყოს მინიმუ 18 წლის" : age),
  numberIsLesser: () => "საგარანტიო ფასი აღემატება საწყის ფასს",
};

@Directive({
  selector: "[appFormErrorMsg]",
})
export class FormErrorMsgDirective implements OnInit, OnDestroy {
  /**
   *
   */
  ref: ComponentRef<ControlErrorComponent>;
  container: ViewContainerRef;

  private statusChangesSubscription: Subscription;

  constructor(
    private element: ElementRef,
    private controlDir: NgControl,
    private resolver: ComponentFactoryResolver,
    private vcr: ViewContainerRef,
  ) {
    this.container = this.vcr;
  }

  ngOnInit() {
    this.statusChangesSubscription = this.control.statusChanges.subscribe(
      (item) => {
        const controlErrors = this.control.errors;
        if (controlErrors) {
          // this.setError(controlErrors);
          this.element.nativeElement.style.borderColor = "red";
        } else {
          // this.setError(null);
          this.element.nativeElement.style.borderColor = "";
        }
        this.setError(this.control.errors);
      },
    );
  }

  get control() {
    return this.controlDir.control;
  }

  setError(error: any) {
    if (!this.ref) {
      const factory = this.resolver.resolveComponentFactory(
        ControlErrorComponent,
      );
      this.ref = this.container.createComponent(factory);
    }
    if (error) {
      const text = Object.keys(error).join(",");
      const errText = error[text];

      if (!Object.keys(customErrorMessages).includes(text)) {
        customErrorMessages[text] = (errText) => errText;
      }
      this.ref.instance.text = customErrorMessages[text](
        Object.values(error[text]),
      );
    } else {
      this.ref.instance.text = "";
    }
  }

  ngOnDestroy() {
    if (this.statusChangesSubscription) {
      this.statusChangesSubscription.unsubscribe();
    }
  }
}
